export default "__VITE_ASSET__vfRHoJlZ__"